export default [
    'DRAFT',
    'SUBMITTED',
    'RESUBMITTED',
    'APPROVED',
    'EXCEPTIONED',
    'DENIED',
    'PAID'
]